// extracted by mini-css-extract-plugin
export var author = "ArArticleAuthors-module--author--2MLwj";
export var container = "ArArticleAuthors-module--container--QzxEe";
export var details = "ArArticleAuthors-module--details--4QZK7";
export var photos = "ArArticleAuthors-module--photos--o9LUF";